import React from "react";
import { Modal } from "../CustomModal/Modal";
import Button from "@material-ui/core/Button";
import "./Popup.scss"

function Popup(props) {
  return (
    <div className="customModal">
      <Modal
        show={props.showCustomModal}
        handleClose={()=>{}}
        parent={"exitsession"}
      >
        <div className="modal_heading">{props.heading}</div>
        <div className="modal_content">{props.content}</div>
        <div className="bottomBtns">
          <Button
            className="CANCELBtn"
            onClick={() => {
              props.setShowCustomModal(false);
            }}
          >
            {props.leftbtn}
          </Button>
          <Button
            className="ADDBtn"
            type="submit"
            onClick={() => {
              props.setShowCustomModal(false);
              props.funOnSuccess();
            }}
          >
            {props.rightbtn}
          </Button>
        </div>
      </Modal>
    </div>
  );
}

export default Popup;


